import React, { Component, useLayoutEffect } from 'react';
import { Grid, Tabs, CircularProgress,Drawer } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import classNames from 'classnames';
import t from '../../utils/translateUtil';
import Typography from '../../components/CustomTypo'
import { LinkRouter } from '../../components/Link';
import ButtonCustom from '../../components/ButtonCustom';
import { PlaceIcon, HomeIcon } from '../../components/icons';
import CustomizedCircularProgress from '../../components/CircularProgress';
import { town_city } from '../../../portal.config';

const styles = theme => ({
    drawerPaper: {
        width: '20%',
        height:'100%',
        backgroundColor: theme.palette.background.drawer,
        [theme.breakpoints.down('xs')]: {
            width: '80%',
        },
    },
    container:{
        padding: theme.spacing(6,2,2,2)
    },
    filter_box:{
        marginTop: theme.spacing(4),
        padding: theme.spacing(2),
        //backgroundColor: theme.palette.background.card,
        //borderRadius: theme.spacing(2)
    },
    // item: {
    //     cursor: "pointer",
    //     paddingRight: theme.spacing(2),
    //     marginTop: theme.spacing(1),
    // },
    // itemContent: {
    //     //fontFamily: theme..primary,
    //     fontSize: "16px",
    //     textTransform:'none',
    //     width: 'auto',
    //     height: theme.spacing(10) + theme.spacing(2),
    //     alignItems: 'center'
    // },
    // primary: {
    //     borderColor: theme.palette.border.primary,
    //     color: theme.palette.text.onPrimary,
    //     backgroundColor: theme.palette.background.tertiary,
    // },
    // default: {
    //     borderColor: theme.palette.border.primary,
    //     color: theme.palette.text.info,
    //     backgroundColor: theme.palette.background.secondary,
    // },

    icon: {
        width: theme.spacing(6),
        height: theme.spacing(6),
        paddingTop: theme.spacing(2) + theme.spacing(2) / 2
    },
    margin: {
        marginBottom: theme.spacing(4)
    },
    padding: {
        paddingLeft: theme.spacing(6),
        paddingRight: theme.spacing(6),
        [theme.breakpoints.down('sm')]: {
            paddingLeft: theme.spacing(4),
            paddingRight: theme.spacing(4),
        },
    },
    rounded6x: {
        borderRadius: theme.spacing(10) + theme.spacing(2),
    },
    rounded2x: {
        borderRadius: theme.spacing(4),
    },
    apply:{
        marginTop: theme.spacing(8)
    }

});
class FilterView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            windowWidth: undefined,
        }
    }
    componentDidMount() {
        this.handleResize();
        window.addEventListener('resize', this.handleResize)
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize)
    }

    handleResize = () => this.setState({
        windowWidth: window.innerWidth
    });

    render() {
        const { filter_options, classes, t, onSelectFilter,filterSelected, onClearFilter, onClose, showLoading, onApplyFilter } = this.props;
       // const {filterSelected} = this.state
       console.log("filterSelected44444====", filterSelected);
        var industries = filter_options.industries;
        var industry_sectors = filter_options.industries;
        var tags = filter_options.industries;
        var townCity = town_city ? town_city : [];
        return (
            <Drawer
                variant="temporary"
                anchor={'right'}
                open={this.props.open}
                onClose={()=>onClose()}
                classes={{
                    paper: classes.drawerPaper
                }}
                ModalProps={{
                    keepMounted: true, // Better open performance on mobile.
                }}>
                <Grid xs={12} item className={classes.container}>
                    <Grid xs={12}>
                        <Typography variant='caption1' color='onPrimary'>{t('filter')}</Typography>
                    </Grid>

                    {showLoading&&<Grid xs={12} item container justify='center'>
                                        <CustomizedCircularProgress/>
                                    </Grid>}
                    <FilterComponent
                        title={'industries'}
                         data={industries}
                         selected={filterSelected.industry}
                         type={'industry'}
                         classes={classes} t={t}
                         onSelectFilter={onSelectFilter}
                     />
                    <FilterComponent
                        title={'industry_sectors'}
                         data={industry_sectors}
                         selected={filterSelected.industry_sector}
                         type={'industry_sector'}
                         classes={classes} t={t}
                         onSelectFilter={onSelectFilter}
                     />
                    <FilterComponent
                    title={'tags'}
                         data={tags}
                         selected={filterSelected.tag}
                         type={'tag'}
                         classes={classes} t={t}
                         onSelectFilter={onSelectFilter}
                     />
                     <FilterComponent
                        title={'town_city'}
                         data={townCity}
                         selected={filterSelected.town_city}
                         type={'town_city'}
                         classes={classes} t={t}
                         onSelectFilter={onSelectFilter}
                     />
                    <Grid item className={classes.apply}>
                        <ButtonCustom fullWidth onClick={onApplyFilter} color='primary'>{t('btn_apply')}</ButtonCustom>
                    </Grid>
                </Grid>    
            </Drawer>
            
        );
    }
}

function FilterComponent(props) {
    var { data, selected, type, onSelectFilter, classes, title } = props;
   // console.log(' type=',type)
  //  console.log(' selected=',selected)
    var filterComponent = [];
    if (data && data.length > 0) {
        data.forEach((filter, index) => {
            var isSelected = false;
            if (selected) {
                for (var i = 0; i < selected.length; i++) {
                    if (selected[i].id === filter.id) {
                        isSelected = true;
                    }
                }
            }
            filterComponent.push(
                <div className={classes.item} key={index}>
                    <ButtonCustom color={!isSelected?'onPrimary':'primary'} onClick={() => onSelectFilter(type, filter)} size='xs'>{filter.name}</ButtonCustom>
                </div>
            )
        });
    }
    return (
        <Grid xs={12} item container className={classes.filter_box}>
            <Typography variant='body2' color='onPrimary'>  {t(title)}</Typography>
            <Grid xs={12} item container>
                {filterComponent}
            </Grid>
            
        </Grid>
    )
}


export default withStyles(styles)(withTranslation()(FilterView));
